import React, { useState, useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormContext } from "./Form";
import { MobileNumberValidationSchema } from "../models/ValidationSchema";
import { checkPhoneExist } from "../api/apiManagement";
import { countries } from "../data/Data";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const PhonePage = () => {
  const { setCurrentStep, data, setData } = useContext(FormContext);
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      select: { value: "852", label: "+852" },
      mobile_number: data.mobile_number != null ? data.mobile_number : null,
    },
    resolver: yupResolver(MobileNumberValidationSchema),
  });

  const [isLoadingButton, setIsLoadingButton] = useState(false);


  const onSubmitPhone = (d) => {
    const phoneData = d.select.value + d.mobile_number;
    setIsLoadingButton(true);
    checkPhoneExist({ phone: phoneData })
      .then((res) => {
  
        if (res.data === 0) {
          setData({
            ...data,
            phone: phoneData,
            mobile_number: d.mobile_number,
          });
          setCurrentStep(1);
        } else if (res.data === 1) {
          setError("mobile_number", { message: "mobile_number" });
        }
        setIsLoadingButton(false);
      })
      .catch((err) => {
    
        setIsLoadingButton(false);
      });
  };

  return (
    <form onSubmit={handleSubmit()}>
      <Box sx={{ height: 100 }}>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <FormControl sx={{ width: 120 }}>
            <InputLabel
              id="country-code-label"
              sx={{ color: !!errors.mobile_number ? "#d32f2f" : "" }}
            >
              <Trans i18nKey="global:country_code" />
            </InputLabel>
            <Controller
              control={control}
              name="select.value"
              render={({ field }) => (
                <Select
                  label={t("global:country_code")}
                  error={!!errors.mobile_number}
                  {...field}
                  labelId="country-code-label"
                  displayEmpty
                  defaultValue={countries[0].value}
                  onChange={(event) => field.onChange(event.target.value)}
                >
                  {countries.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
          <TextField
            fullWidth
            error={!!errors.mobile_number}
            label={t("global:phone_number")}
            {...register("mobile_number", { required: "fieldRequired" })}
          />
        </Box>
        {(errors.mobile_number ) && (
          <FormHelperText error>
            <Trans i18nKey="global:phone_number_error" />
          </FormHelperText>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingButton
          onClick={handleSubmit(onSubmitPhone)}
          loading={isLoadingButton}
          variant="outlined"
        >
          <div className="input-text">
            <Trans i18nKey="global:next" />
          </div>
        </LoadingButton>
      </Box>
    </form>
  );
};

export default PhonePage;
